var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { name: "answered" } }, [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _vm._v(" " + _vm._s(_vm.$t("callEvents.answeredCalls")) + " "),
                _vm.counts.answered > 0
                  ? _c("el-badge", {
                      staticClass: "tab-badge",
                      attrs: { value: _vm.counts.answered, type: "success" },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("el-tab-pane", { attrs: { name: "missed" } }, [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _vm._v(" " + _vm._s(_vm.$t("callEvents.missedCalls")) + " "),
                _vm.counts.missed > 0
                  ? _c("el-badge", {
                      staticClass: "tab-badge",
                      attrs: { value: _vm.counts.missed, type: "danger" },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("el-tab-pane", { attrs: { name: "failed" } }, [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _vm._v(" " + _vm._s(_vm.$t("callEvents.failedCalls")) + " "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      placement: "top",
                      content: _vm.$t("callEvents.failedCallsHint"),
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-question",
                      staticStyle: { "margin-left": "4px", color: "#909399" },
                    }),
                  ]
                ),
                _vm.counts.failed > 0
                  ? _c("el-badge", {
                      staticClass: "tab-badge",
                      attrs: { value: _vm.counts.failed, type: "warning" },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "200px", "margin-right": "20px" },
            attrs: {
              type: "date",
              placeholder: "Start Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.listQuery.startDate,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "startDate", $$v)
              },
              expression: "listQuery.startDate",
            },
          }),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "200px", "margin-right": "20px" },
            attrs: {
              type: "date",
              placeholder: "End Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.listQuery.endDate,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "endDate", $$v)
              },
              expression: "listQuery.endDate",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "130px", "margin-right": "20px" },
              attrs: { placeholder: "Country", clearable: "" },
              model: {
                value: _vm.listQuery.country,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "country", $$v)
                },
                expression: "listQuery.country",
              },
            },
            _vm._l(_vm.countryOptions, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { label: item.displayName, value: item.key },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px", "margin-right": "20px" },
              attrs: { placeholder: "Category", clearable: "", filterable: "" },
              model: {
                value: _vm.listQuery.category,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "category", $$v)
                },
                expression: "listQuery.category",
              },
            },
            [
              _c("el-option", {
                attrs: { label: _vm.$t("callEvents.noSubject"), value: "none" },
              }),
              _vm._l(_vm.categoryOptions, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: String(item.id) },
                })
              }),
            ],
            2
          ),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px", "margin-right": "20px" },
            attrs: { placeholder: "User ID", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.listQuery.userId,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "userId", $$v)
              },
              expression: "listQuery.userId",
            },
          }),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "220px", "margin-right": "20px" },
            attrs: { placeholder: "Search (email, name)", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.listQuery.text,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "text", $$v)
              },
              expression: "listQuery.text",
            },
          }),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.resetFilters },
            },
            [_vm._v(" Reset ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { "margin-bottom": "20px" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading...",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("callEvents.callId"),
              align: "center",
              width: "90",
              fixed: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: `room: ${row.roomSid || "—"}`,
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-family": "monospace",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v("#" + _vm._s(row.id))]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "User",
              align: "left",
              "min-width": "200",
              fixed: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(row.firstName) + " " + _vm._s(row.lastName)
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticStyle: { "font-size": "12px", color: "#888" } },
                      [_vm._v(_vm._s(row.email))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Category", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.categoryId
                      ? _c("span", [_vm._v(_vm._s(_vm.categoryName(row)))])
                      : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Country", align: "center", width: "70" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(row.country || row.userCountry) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.callStatusType(row.callStatus),
                          size: "mini",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.callStatus || "—") + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Started", align: "center", width: "135" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatDate(row.userCallStart || row.userCreatedAt)
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Ended", align: "center", width: "135" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatDate(row.userCallEnd || row.userUpdatedAt)
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Duration", align: "center", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.userDuration || 0) + "s ")]
                },
              },
            ]),
          }),
          _vm.activeTab !== "answered"
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("callEvents.diagnosis"),
                  align: "center",
                  width: "240",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("callEvents.regionCandidates")
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.assistantCandidateCount === null ||
                                          row.assistantCandidateCount ===
                                            undefined
                                          ? row.assistantsNotifiedCount ===
                                              null ||
                                            row.assistantsNotifiedCount ===
                                              undefined
                                            ? _vm.$t(
                                                "callEvents.noRecordPrePhase2"
                                              )
                                            : row.assistantsNotifiedCount
                                          : row.assistantCandidateCount
                                      )
                                  ),
                                  _c("br"),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("callEvents.connectedAtTime")
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.assistantsNotifiedCount === null ||
                                          row.assistantsNotifiedCount ===
                                            undefined
                                          ? "—"
                                          : row.assistantsNotifiedCount
                                      )
                                  ),
                                  _c("br"),
                                  _c("strong", [
                                    _vm._v("WS confirm (recipientCount>0):"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.actuallyDeliveredCount === null ||
                                          row.actuallyDeliveredCount ===
                                            undefined
                                          ? "—"
                                          : row.actuallyDeliveredCount
                                      )
                                  ),
                                  _c("br"),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("callEvents.panelsCaughtNewCall")
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.panelAckedCount === null ||
                                          row.panelAckedCount === undefined
                                          ? 0
                                          : row.panelAckedCount
                                      )
                                  ),
                                  _c("br"),
                                  _c("strong", [
                                    _vm._v("Zoom user_joined event:"),
                                  ]),
                                  _vm._v(" " + _vm._s(row.joinEventCount || 0)),
                                  _c("br"),
                                  _c("br"),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("callEvents.hintNotConnected")
                                      )
                                    ),
                                  ]),
                                  _c("br"),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("callEvents.hintPanelFailed")
                                      )
                                    ),
                                  ]),
                                  _c("br"),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(_vm.$t("callEvents.hintNoAccept"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.diagnosticType(row),
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.diagnosticLabel(row)) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3786032801
                ),
              })
            : _vm._e(),
          _vm.activeTab === "answered"
            ? _c("el-table-column", {
                attrs: {
                  label: "Assistant",
                  align: "left",
                  "min-width": "200",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.assistantFirstName || row.assistantLastName
                            ? _c("div", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(row.assistantFirstName) +
                                      " " +
                                      _vm._s(row.assistantLastName)
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#888",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.assistantEmail))]
                                ),
                              ])
                            : _c(
                                "span",
                                { staticStyle: { color: "#c0c4cc" } },
                                [_vm._v("—")]
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  418137118
                ),
              })
            : _vm._e(),
          _vm.activeTab === "answered"
            ? _c("el-table-column", {
                attrs: { label: "Joined", align: "center", width: "135" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(row.assistantJoinedAt)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  974608555
                ),
              })
            : _vm._e(),
          _vm.activeTab === "answered"
            ? _c("el-table-column", {
                attrs: { label: "Wait", align: "center", width: "70" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              style:
                                row.waitSeconds > 30 ? "color: #e6a23c;" : "",
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.computeWaitSeconds(row)) + "s "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1169363704
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "Survey", align: "center", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.surveyIsAnswered
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.surveyIsSatisfied
                                    ? "success"
                                    : "warning",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.surveyIsSatisfied
                                        ? "Satisfied"
                                        : "Not satisfied"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            row.surveyDescription
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#888",
                                      "margin-top": "4px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(row.surveyDescription) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                          _vm._v("—"),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-size": _vm.listQuery.pageSize,
          "page-sizes": [10, 20, 50, 100, 200],
          background: true,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.totalCount,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }